export const namespaced = true

export const state = {
  bookingFocusRequest: {
    bookingId: null,
    requestId: 0
  },
  highlightedBookingIds: []
}

export const mutations = {
  SET_BOOKING_FOCUS_REQUEST (state, bookingId) {
    state.bookingFocusRequest = {
      bookingId,
      requestId: state.bookingFocusRequest.requestId + 1
    }
  },
  CLEAR_BOOKING_FOCUS_REQUEST (state, requestId) {
    if (state.bookingFocusRequest.requestId === requestId) {
      state.bookingFocusRequest = {
        bookingId: null,
        requestId
      }
    }
  },
  SET_HIGHLIGHTED_BOOKING_IDS (state, bookingIds) {
    state.highlightedBookingIds = bookingIds
  }
}

export const actions = {
  requestBookingFocus ({ commit }, bookingId) {
    commit('SET_BOOKING_FOCUS_REQUEST', bookingId)
  },
  consumeBookingFocus ({ commit }, requestId) {
    commit('CLEAR_BOOKING_FOCUS_REQUEST', requestId)
  },
  highlightBookings ({ state, commit }, bookingIds) {
    const highlightedBookingIds = [...new Set([
      ...state.highlightedBookingIds,
      ...bookingIds
    ].map(Number).filter(Boolean))]
    commit('SET_HIGHLIGHTED_BOOKING_IDS', highlightedBookingIds)
  },
  unhighlightBookings ({ state, commit }, bookingIds) {
    const removedBookingIds = new Set(bookingIds.map(Number))
    commit('SET_HIGHLIGHTED_BOOKING_IDS', state.highlightedBookingIds.filter(bookingId => !removedBookingIds.has(bookingId)))
  },
  clearHighlightedBookings ({ commit }) {
    commit('SET_HIGHLIGHTED_BOOKING_IDS', [])
  }
}
